import { lazy } from "react";

export { ADMIN_PANEL_ROLE_EDIT_PATH } from "./edit-role-path";
export const EditRole = lazy(() => import("./edit-role"));
export { ToEditRole } from "./to-edit-role";
